import { CHECKIN_QUESTION_VISIBILITY } from 'constants/ProjectConstants';

// Class EngagementTemplateDetails extends this class.
export class CheckInTemplateDetails {
  constructor({
    id,
    name,
    isArchived,
    templateQuestions,
    templateSetting,
    modifiable = true,
    isSample = false,
    formType,
    createdByEmployeeId,
  }) {
    this.id = id;
    this.name = name;
    this.isArchived = isArchived;
    this.templateQuestions = templateQuestions;
    this.templateSetting = templateSetting;
    this.modifiable = modifiable;
    this.isSample = isSample;
    this.formType = formType;
    this.createdByEmployeeId = createdByEmployeeId;
  }

  static fromJSON({
    id,
    name,
    isArchived,
    templateQuestions,
    templateSetting,
    modifiable,
    isSample,
    formType,
    createdByEmployeeId,
  }) {
    return new CheckInTemplateDetails({
      id,
      name,
      isArchived,
      templateQuestions: templateQuestions?.map((ques) => CheckInTemplateQuestion.fromJSON(ques)) || [],
      templateSetting: CheckInTemplateSetting.fromJSON(templateSetting || {}),
      modifiable,
      isSample,
      formType,
      createdByEmployeeId,
    });
  }
}

export class CheckInTemplateQuestion {
  constructor({
    question,
    questionType,
    displayOrder,
    visibility,
    isRequired,
    organizationTag,
    templateId,
    weightage,
  }) {
    this.question = question;
    this.questionType = questionType;
    this.displayOrder = displayOrder;
    this.visibility = visibility;
    this.isRequired = isRequired;
    this.organizationTag = organizationTag;
    this.templateId = templateId;
    this.weightage = weightage;
  }

  static fromJSON({
    question,
    questionType,
    displayOrder,
    visibility,
    isRequired,
    organizationTag,
    templateId,
    weightage,
  }) {
    return new CheckInTemplateQuestion({
      question,
      questionType,
      displayOrder,
      visibility: visibility || CHECKIN_QUESTION_VISIBILITY.both.value,
      isRequired: isRequired !== undefined ? isRequired : true,
      organizationTag,
      templateId,
      weightage,
    });
  }
}

class CheckInTemplateSetting {
  constructor({ carryForwardAgenda, forwardActionItems, id, templateId }) {
    this.id = id;
    this.carryForwardAgenda = carryForwardAgenda;
    this.forwardActionItems = forwardActionItems;
    this.templateId = templateId;
  }

  static fromJSON({ carryForwardAgenda = false, forwardActionItems = true, id, templateId }) {
    return new CheckInTemplateSetting({
      carryForwardAgenda,
      forwardActionItems,
      id,
      templateId,
    });
  }
}
